import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import * as $ from 'jquery';
import {ISucursal} from './sucursal';
import {Observable} from 'rxjs';
import {SucursalesService} from './sucursales.service';
import {SucursalesListComponent} from './sucursales-list.component';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {HttpErrorResponse} from '@angular/common/http';
import {NegociosService} from '../negocios/negocios.service';
import {Negocio} from '../negocios/negocio';
import * as myGlobals from './../global';
import {HttpErrorValidator} from '../services/http-error-validator';

@Component({
  selector: 'pm-sucursales',
  templateUrl: './sucursales.component.html',
  styleUrls: ['./sucursales.component.sass']
})
export class SucursalesComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'SUCURSALES';

  sucursales: ISucursal[] = [];
  filteredSucursales: ISucursal[] = [];
  errorMessage = '';
  currentPg = 1;

  private _searchName = '';

  businessList: Observable<Negocio[]> = this.businessService.allRecords();

  constructor(
    public service: SucursalesService,
    private parent: SucursalesListComponent,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private businessService: NegociosService,
    private httpErrorValidator: HttpErrorValidator
  ) {
  }

  ngAfterViewInit() {
    // $('#menu-catalogos').click();
    $('a[rel=sucursales]').addClass('selected');
  }

  get searchName(): string {
    return this._searchName;
  }

  set searchName(value: string) {
    console.log('searchName: _searchName: ', value);
    this._searchName = value;
    const filters = {
      name: [this._searchName],
      nodeIdentifier: [this._searchName] // ['Blue', 'Black'],
    };
    this.filteredSucursales = this.filterSucursales();
    console.log(this.filteredSucursales.length);

  }

  filterSucursales() {
    console.log('filterSucursales: _searchName: [', this._searchName.trim(), ']');
    return this.sucursales.filter(sucursal => this.filterField(sucursal));
  }

  filterField(sucursal: ISucursal) {
    if (this._searchName.trim() !== ' ') {
      if (sucursal.name.toLowerCase().indexOf(this._searchName) !== -1) {
        return true;
      }

      const sNodeId = '' + sucursal.nodeIdentifier;
      if (sNodeId.toLowerCase().startsWith(this._searchName)) {
        return true;
      }

      if (sucursal.affiliationNumber1 != null
        && this._searchName.length >= 4
        && sucursal.affiliationNumber1.startsWith(this._searchName)) {
        return true;
      }

      if (sucursal.affiliationNumber2 != null
        && this._searchName.length >= 4
        && sucursal.affiliationNumber2.startsWith(this._searchName)) {
        return true;
      }
    }
    return false;
  }

  newSucursal(): void {
    this.parent.showEditSucursal = false;
    this.parent.showSucursales = false;
    this.parent.showAddSucursal = true;
  }

  ngOnInit(): void {
    this.spinner();
    this.service.getSucursales().subscribe(
      res => {
        this.sucursales = res;
        this.filteredSucursales = this.sucursales;
      },
      err => this.httpErrorValidator.validateError(err)
    );
  }

  edit(elemento, index: number) {
    console.log('Entrando: index: ', index);
    console.log('Entrando: id: ', elemento.id);
    this.parent.editnumber = elemento.id;
    this.parent.showSucursales = false;
    this.parent.showAddSucursal = false;
    this.parent.showEditSucursal = true;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  public ngOnDestroy(): void {
    $('a[rel=sucursales]').removeClass('selected');
  }
}
